import { defineStore } from 'pinia';

export const useAppointmentReferralStore = defineStore('appointmentReferralStore', {
	// Below sets up https://github.com/prazdevs/pinia-plugin-persistedstate, stored to session base64 encoded 
	persist: {
		storage: sessionStorage,
		serializer: {
			serialize: state => btoa(JSON.stringify(state)),
			deserialize: storeState => JSON.parse(atob(storeState)),
		  },
	},
	state: () => ({
		postcode: '',
		profession: '',
		existingCustomerDetails: null,
		financialAdviser: null,
		financialAdviserName: '',
		financialAdviserLocation: '',
		financialAdviserSegment: '',
		returnedDetails: null,
		finalSubmissionData: null,
		existingCustomer: false,
		preferredContactTime: '',
		selectedCustomerType: null,
		customerProfession: null,
		knowTheirFC: null,
		selectedKnownFC: null,
		selectedAdviser: null,
	}),
	getters: {
		getAllDataForExistingCustomerSubmission() {
			return {
				"contactId": this.returnedDetails?.contactId,
				"campaignCode": "",
				// "forename":,
				"email": this.existingCustomerDetails?.email,
				"contactNumber": this.finalSubmissionData?.phoneNumber,
				"preferredContactTime": this.finalSubmissionData?.selectedTime,
				"marketingPreferences": this.finalSubmissionData?.contactMethod,
				"discussionTopics": this.finalSubmissionData?.discuss,
				"nominatedManagingAdviserId": this.selectedAdviser?.wesAdviserNumberCdsKey,
			}
		},
		getAllDataForNewCustomerSubmission() {
			return {
				"campaignCode": "",
				"forename": this.finalSubmissionData?.firstName,
				"surname": this.finalSubmissionData?.surname,
				"email": this.finalSubmissionData?.email,
				"contactNumber": this.finalSubmissionData?.phoneNumber,
				"preferredContactTime": this.finalSubmissionData?.selectedTime,
				"marketingPreferences": this.finalSubmissionData?.contactMethod,
				"discussionTopics": this.finalSubmissionData?.discuss,
				"homeAddressLine1": this.finalSubmissionData?.houseNumber,
				"homePostcode": this.finalSubmissionData?.postcode,
				"workPostcode": this.finalSubmissionData?.postcode,
				"segment": this.profession.type,
				"preferredContactTime": this.finalSubmissionData?.selectedTime,
				"marketingPreferences": this.finalSubmissionData?.contactMethod,
				"discussionTopics": this.finalSubmissionData?.discuss,
				"nominatedManagingAdviserId": this.selectedAdviser?.wesAdviserNumberCdsKey,
			}
		},
		professionAndPostcode() {
			return {
				profession: this.profession,
				postcode: this.postcode,
			};
		},
	},
	actions: {
		postCustomerProfession(selected) {
			this.customerProfession = selected;
		},
		postSelectedCustomerType(selected) {
			this.selectedCustomerType = selected;
		},
		postSelectedKnownFC(selected) {
			this.selectedKnownFC = selected;
		},
		postCustomerType(type) {
 			this.existingCustomer = type;
		},
		postKnownFC(type) {
			this.knowTheirFC = type;
	   },
	   postSelectedAdviser(adviser) {
			this.selectedAdviser = adviser;
	   },
		postFinalSubmissionData(finalSubmissionData) {
			this.finalSubmissionData = finalSubmissionData;
		},
		postPostcode(postcode) {
			this.postcode = postcode;
		},
		postProfession(profession) {
			this.profession = profession;
		},
		postFinancialAdviser(financialAdviser) {
			this.financialAdviser = JSON.parse(financialAdviser);
			this.financialAdviserLocation = this.financialAdviser?.area;
			this.financialAdviserName = `${this.financialAdviser?.firstName} ${this.financialAdviser?.lastName}`;
			this.financialAdviserSegment = this.financialAdviser?.segment;
		},
		postFinancialAdviserCookie(financialAdviser) {
			this.financialAdviser = financialAdviser;
			this.financialAdviserLocation = this.financialAdviser?.area;
			this.financialAdviserName = `${this.financialAdviser?.firstName} ${this.financialAdviser?.lastName}`;
			this.financialAdviserSegment = this.financialAdviser?.segment;
		},
		postExistingCustomerDetails(customerDetails, returnedDetails) {
			returnedDetails = JSON.parse(returnedDetails);
			this.existingCustomerDetails = customerDetails;
			this.returnedDetails = returnedDetails;
			this.financialAdviser = returnedDetails;
			this.financialAdviserLocation = returnedDetails?.area ?? '';
			this.profession = returnedDetails?.segment;
			this.financialAdviserName = `${returnedDetails?.firstName} ${returnedDetails?.lastName}`;
		},
		resetExistingCustomerDetails() {
			this.existingCustomerDetails = '';
		},
		resetNewUserDetails() {
			this.postcode = '';
			this.profession = '';
		},
	},
});
